import { render, staticRenderFns } from "./gatherUpload.vue?vue&type=template&id=08faad3f&scoped=true"
import script from "./gatherUpload.vue?vue&type=script&lang=js"
export * from "./gatherUpload.vue?vue&type=script&lang=js"
import style0 from "./gatherUpload.vue?vue&type=style&index=0&id=08faad3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08faad3f",
  null
  
)

export default component.exports